<div class="riskline-attribution"
  [class.riskline-attribution-compact]="compact"
  [class.text-end]="alignEnd"
>

  @if (showPoweredBy || showSourceToggle) {
    <div class="riskline-credit-row" [class.justify-content-end]="alignEnd">

      @if (showPoweredBy) {
        <span class="text-muted small">{{ creditText }}</span>
      }

      @if (showSourceToggle) {
        <span class="riskline-source-toggle">
          <span class="form-check form-check-inline">
            <input
              [checked]="dataSourceID===eTravelRiskDataProvider.Riskline"
              class="form-check-input"
              [id]="'rlSrcRiskline' + instanceId"
              [name]="'rlSrc' + instanceId"
              type="radio"
              (change)="selectSource(eTravelRiskDataProvider.Riskline)"
            >
            <label class="form-check-label" [attr.for]="'rlSrcRiskline' + instanceId">Riskline</label>
          </span>
          <span class="form-check form-check-inline">
            <input
              [checked]="dataSourceID===eTravelRiskDataProvider.SureSIM"
              class="form-check-input"
              [id]="'rlSrcSureSim' + instanceId"
              [name]="'rlSrc' + instanceId"
              type="radio"
              (change)="selectSource(eTravelRiskDataProvider.SureSIM)">
            <label class="form-check-label" [attr.for]="'rlSrcSureSim' + instanceId">SureSIM</label>
          </span>
        </span>
      }

    </div>
  }

  @if (showSafetyDisclaimer) {
    <div class="text-muted riskline-safety-disclaimer">
      You acknowledge and accept that you shall at all times respect all safety alerts and
      instructions and in addition take all relevant precautions and comply with general rules
      on safety. Nothing in the content or the service is intended to replace your own risk
      assessment, common sense or general principles on good safety and personal security. You
      further acknowledge and accept that even though there may not be any active reports for an
      area that does not mean that the area is safe, and general safety should always be a concern.
    </div>
  }
</div>
